export default __webpack_public_path__ + "static/media/bell.717c5cdd.svg";